// extracted by mini-css-extract-plugin
export default {"login-page-wrapper":"LoginPage_login-page-wrapper__+TOoW","back-button":"LoginPage_back-button__WPeEY"};